/**
 * Волна 35: найм ботов в конце партии и найм под гарнизоны (этап найма,
 * utils/bots/decisions/decideRecruitmentStep). Каждая подчасть — за своим
 * гейтом A/B в utils/bots/abTestGates.js, legacy-игрок нанимает прежним кодом
 * дословно.
 *
 * R — найм в конце партии с горизонтом (гейт isPreW35LateHirePlayer).
 *  Откуда: реплеи прода с 05.10. В R12 41–43% монет найма бота уходили в
 *  отряды и размер, которые до конца партии ни с кем не столкнулись, ничего не
 *  захватили и не держали угрожаемый город (R10 — около 20%). Новые отряды R12
 *  в матчах theLupaChose: 947 монет, убийств на 70 очков, отдано врагу 131.
 *  Просветлённые (курс монет в очки 1:1) теряли так около 4.5 очка за партию.
 *  Найм размера существующим отрядам в R11, наоборот, окупается (121 очко за
 *  убийства против 71 отданного). Поэтому в последних раундах новый отряд —
 *  только заслон угрожаемого города или под цель, до которой он успеет дойти,
 *  а размер — только отрядам в контакте, держателям открытых городов и под
 *  досягаемую цель. Просветлённые и игроки с FANATICISM — только заслоны и
 *  держатели угрожаемых городов.
 *
 * G-найм — гарнизоны по доктрине фракции (только боты с бонусом «большой» и выше —
 *  checkIfW35GarrisonPlayer, гейт isPreW35GarrisonPlayer; сами гарнизоны —
 *  utils/bots/evaluation/garrisons.js, константы — botGarrison.js).
 *  Держатель-одиночка угрожаемого города в проде — медиана размера 3 против
 *  захватчика 7, поэтому размер в первую очередь докупается слабым держателям
 *  гарнизонов. Город экономической доктрины, открытый для противника и без
 *  гарнизона, получает заслон на казарме, как при угрозе следующего раунда.
 *  Бюджет найма это не разгоняет: волна 32 («больше трат на армию») стоила
 *  −0.63 очка, поэтому доплачивается только держателям, а не всем отрядам.
 *
 * G-найм, держатель из накоплений (G v2, все доктрины). Разведка прода: боты
 *  копят монеты (после хода войны R9–10 ≈20, R11–13 ≈44), армии в 2–2.7 раза
 *  меньше, чем у сильного человека, и в 46% ходов с пустым угрожаемым городом на
 *  руках ≥10 монет. Обязательный по доктрине город под угрозой «скоро» и выше без
 *  держателя, до свободного квартала которого этим ходом не дойдет ни один свой
 *  отряд, получает заслон на своей казарме, смежной свободному кварталу, — если
 *  свободных монет (сверх накоплений на стройку) хватает на отряд, на размер,
 *  переживающий ожидаемый урон ближайшего врага (calcW35HolderSizePurchases), и
 *  на запас W35_HOLDER_HIRE_COIN_MARGIN. Слабому держателю такого города
 *  (и заслону на его казарме, который пока город не удержит) размер докупается
 *  раньше найма новых отрядов. Общий найм это не разгоняет: только под
 *  обязательные города без держателя, в пределах потолков отрядов и ферм.
 */

// ---- G-найм: держатель из накоплений ----
// Запас свободных монет сверх цены заслона и размера, который ему нужен.
// Контрфактика прода (cf_v2, 385 матчей): у кандидатов на руках медиана 13 монет
// (p25 8, p75 27), накоплений на стройку в 92% случаев нет, план «заслон + размер» —
// в среднем 3.7 монеты (d6 в 83% наймов). Доля кандидатов, которых город потом взяли
// люди (r0/r1), от запаса не зависит (8.1–8.6% при запасе 0–10), запас меняет лишь
// число наймов: 0 — 86% кандидатов, 2 — 79%, 4 — 71%, 10 — 47%. 2 оставляет монеты
// на покупку размера в следующей фазе и почти не режет найм
export const W35_HOLDER_HIRE_COIN_MARGIN = 2;

/**
 * Сколько покупок размера нужно заслону, чтобы пережить ожидаемый урон
 * expectedDamage (размер больше урона, как у выбора держателя гарнизона):
 * покупка дает sizePerPurchase (1, с рабочим арсеналом 2) и занимает квартал
 * города — за фазу их не больше quartersCount. Возвращает {purchases — покупок в
 * эту фазу, isEnough — размера хватит уже в эту фазу}; null — тип не переживет
 * урон и на максимуме размера
 */
export const calcW35HolderSizePurchases = ({initialSize = 1, expectedDamage, maxSize, sizePerPurchase, quartersCount}) => {
  const requiredSize = Math.floor(Math.max(0, expectedDamage)) + 1;
  if (maxSize < requiredSize) {
    return null;
  }
  const needed = Math.max(0, Math.ceil((requiredSize - initialSize) / Math.max(1, sizePerPurchase)));
  const purchases = Math.min(needed, Math.max(0, quartersCount));
  return {purchases, isEnough: purchases >= needed};
};

// ---- R: окно конца партии ----
// Последние раунды, в которых найм проверяет горизонт: раунд ≥ лимит партии −
// это число. При лимите 13 — R11 и R12 (в последнем раунде этап найма бот
// пропускает целиком)
export const W35_LATE_HIRE_WINDOW_ROUNDS = 2;

// С раунда «лимит − это число» найм размера открыт всем архетипам — но теперь
// только под цель или угрозу, а не по номеру раунда. Прежнее правило — с
// SIZE_HIRE_LATE_GAME_ROUND = 10 при лимите 13 (то же значение)
export const W35_LATE_SIZE_HIRE_ROUNDS_BEFORE_LIMIT = 3;

// Запас клеток к досягаемости цели «скорость × оставшиеся перемещения».
// BFS по полю и так оптимистична: пустые клетки в ней не обрывают ход
export const W35_LATE_HIRE_REACH_SLACK = 0;

// Контакт для докупки размера: противник встанет рядом с отрядом за одно свое
// перемещение — его скорость плюс доп. снабжение и удар с соседней клетки
export const W35_LATE_HIRE_CONTACT_EXTRA_CELLS = 2;

/**
 * Окно конца партии: раунд ≥ лимит − W35_LATE_HIRE_WINDOW_ROUNDS.
 * roundLimit — getRoundLimit(selectFinalRound(state)); null — раунды не
 * ограничены, конца партии нет
 */
export const checkIfLateHireWindow = (round, roundLimit) => (
  roundLimit !== null && Number.isFinite(round) && round >= roundLimit - W35_LATE_HIRE_WINDOW_ROUNDS
);

/** Перемещений до конца партии, считая текущую фазу войны (нанятый отряд ходит в ней же) */
export const calcLateHireRemainingMoves = (round, roundLimit) => (
  roundLimit === null ? Infinity : Math.max(0, roundLimit - round + 1)
);

/** С какого раунда найм размера открыт всем архетипам (без лимита партии — fallbackRound) */
export const calcLateSizeHireRound = (roundLimit, fallbackRound) => (
  roundLimit === null ? fallbackRound : roundLimit - W35_LATE_SIZE_HIRE_ROUNDS_BEFORE_LIMIT
);

/**
 * Цель досягаема до конца партии: отряд встанет на чужой квартал или рядом с
 * чужим отрядом (удар с соседней клетки). unitDistance/quarterDistance —
 * BFS-дистанции от клетки отряда до ближайшего чужого отряда и квартала
 * (undefined — недосягаемо); speed — клеток за перемещение
 */
export const checkIfLateHireTargetInReach = ({unitDistance, quarterDistance, speed, remainingMoves, extraCells = 0}) => {
  if (!(remainingMoves > 0)) {
    return false;
  }
  const reach = speed * remainingMoves + extraCells + W35_LATE_HIRE_REACH_SLACK;
  return (Number.isFinite(unitDistance) && unitDistance - 1 <= reach)
    || (Number.isFinite(quarterDistance) && quarterDistance <= reach);
};
